import { object, string } from 'yup';
import i18n from '../../../i18n';

export const UserGroupFormSchema = object({
    name: string()
        .trim()
        .required(() => i18n.t('validation:required')),
});
